import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ImportDetail from './ImportMenu/ImportDetail';
import { useShipmentDetails } from './ImportMenu/useShipmentDetails';
import CustomCollapse from '../common/CustomCollapse';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import CustomLoader from '../common/CustomLoader';
import { ImportTask } from './ImportMenu/ImportTask';
import { ImportCall } from './ImportMenu/ImportCall';
import { ImportNotes } from './ImportMenu/ImportNotes';

export default function PersistentDrawerLeft() {
    const { importShipmentId } = useParams();
    const { shipmentDetails, loading: shipmentLoading } = useShipmentDetails(importShipmentId);
    if (!shipmentDetails) {
        return <p> <CustomLoader open={shipmentLoading} /> </p>;
    }
    const firstName = shipmentDetails.user.firstName;
    const lastName = shipmentDetails.user.lastName;
    const email = shipmentDetails.user.email;
    const mobile =
        shipmentDetails?.user?.mobile && shipmentDetails?.user?.phonecode?.phonecode
            ? `+${shipmentDetails.user.phonecode.phonecode}${shipmentDetails.user.mobile}`
            : shipmentDetails?.user?.mobile || '';
    const companyName = shipmentDetails.supplier.clientCompanyName;
    const phoneNumber = shipmentDetails.supplier.mobile;
    const initial = shipmentDetails.supplier.clientCompanyName ? shipmentDetails.supplier.clientCompanyName.charAt(0).toUpperCase() : '';

    const adminData = [
        {
            title: "Owner",
            defaultExpanded: false,
            details: [
                { label: 'Owner', value: `${firstName || ''} ${lastName || ''}`.trim() },
                { label: 'Email', value: email, sm: 12, md: 12 },
                { label: 'Mobile', value: mobile, sm: 12, md: 12 },

            ],
        },
    ];

    return (
        <div>
            <ImportDetail />
            <br />
            <ImportCall importShipmentId={importShipmentId} data={shipmentDetails} />
            <br />
            <ImportTask importShipmentId={importShipmentId} data={shipmentDetails} />
            <br />
            <ImportNotes importShipmentId={importShipmentId} data={shipmentDetails} />
            <br />
            <CustomCollapse Icon={PersonOutlineOutlinedIcon} data={adminData} />
            <br />
        </div>
    );
}
